import { AnyAction, combineReducers, configureStore, Reducer } from '@reduxjs/toolkit';
import { CLEAR_ALL_STATE } from '../../../redux/modules/actionTypes';
import { approvalsReducer } from "../../../redux/modules/approvals";
import { contentManagerDirectoryReducer } from '../../../redux/modules/contentManagerDirectory';
import { currentSharepointFolderReducer } from "../../../redux/modules/currentSharepointFolder";
import { datasourceReducer } from "../../../redux/modules/datasource";
import { expandersReducer } from "../../../redux/modules/expanders";
import { fileReducer } from "../../../redux/modules/file";
import { loadingReducer } from "../../../redux/modules/loader";
import { modeReducer } from "../../../redux/modules/mode";
import { oneDriveReducer } from "../../../redux/modules/oneDrive";
import { pinnedReducer } from "../../../redux/modules/pinnedItems";
import { recentReducer } from "../../../redux/modules/recentItems";
import { regionalSettingsReducer } from "../../../redux/modules/regional";
import { reloadReducer } from "../../../redux/modules/reload";
import { savingInBackgroundReducer } from "../../../redux/modules/savingInBackground";
import { savingLocationReducer } from "../../../redux/modules/savingLocation";
import { searchReducer } from "../../../redux/modules/search";
import { sharedReducer } from "../../../redux/modules/sharedItems";
import { suggestedReducer } from "../../../redux/modules/suggestedItems";
import { sharePointInfoReducer } from "../../../redux/modules/sharepointInfo";
import { showFolderDeleteDialogReducer } from "../../../redux/modules/showFolderDeleteDialogue";
import { teamsReducer } from "../../../redux/modules/teams";
import { tenantReducer } from "../../../redux/modules/tenant";
import { userReducer } from "../../../redux/modules/user";
import { workingDirectoryReducer } from "../../../redux/modules/workingDirectory";
import { apiGraphSlice } from "./api/graph/api-graph-slice";
import { apiGraphInsightsSlice } from "./api/graph/api-graph-insights-slice";
import { apiPiiSlice } from "./api/local/api-pii-slice";
import { apiSharePointSlice } from "./api/sharepoint/api-sharepoint-slice";
import { apiNintexSlice } from "./api/nintex/api-nintex-slice";
import { overlayReducer } from '../../../redux/modules/overlay';
import { cacheUpdateReducer } from '../../../redux/modules/cacheUpdate';

const combinedReducer = combineReducers({
  savingLocation: savingLocationReducer,
  workingDirectories: workingDirectoryReducer,
  tenantInfo: tenantReducer,
  datasource: datasourceReducer,
  files: fileReducer,
  savingInBackground: savingInBackgroundReducer,
  reload: reloadReducer,
  currentSharepointFolder: currentSharepointFolderReducer,
  sharePointInfo: sharePointInfoReducer,
  mode: modeReducer,
  loading: loadingReducer,
  expanders: expandersReducer,
  user: userReducer,
  search: searchReducer,
  teams: teamsReducer,
  oneDrive: oneDriveReducer,
  regionalSettings: regionalSettingsReducer,
  pinned: pinnedReducer,
  recent: recentReducer,
  shared: sharedReducer,
  suggested: suggestedReducer,
  showFolderDeleteDialog: showFolderDeleteDialogReducer,
  approvals: approvalsReducer,
  contentManagerDirectory: contentManagerDirectoryReducer,
  overlay: overlayReducer,
  cacheUpdate: cacheUpdateReducer,
  [apiPiiSlice.reducerPath]: apiPiiSlice.reducer,
  [apiGraphSlice.reducerPath]: apiGraphSlice.reducer,
  [apiGraphInsightsSlice.reducerPath]: apiGraphInsightsSlice.reducer,
  [apiSharePointSlice.reducerPath]: apiSharePointSlice.reducer,
  [apiNintexSlice.reducerPath]: apiNintexSlice.reducer,
});

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === CLEAR_ALL_STATE) {
    // return combinedReducer(undefined, action);
    state = {} as RootState;
  }
  return combinedReducer(state, action);
};

export const storeMain = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false
    })
      .concat(
        apiPiiSlice.middleware,
        apiGraphSlice.middleware,
        apiGraphInsightsSlice.middleware,
        apiSharePointSlice.middleware,
        apiNintexSlice.middleware,
      );
  },
});

export type AppDispatch = typeof storeMain.dispatch;
export type RootState = ReturnType<typeof storeMain.getState>;